import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./OverlayPortal.module.scss";

interface OverlayPortalProps {
  onClick: () => void;
}

const OverlayPortal: React.FC<OverlayPortalProps> = ({ onClick }) => {
  const el = document.createElement("div");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    document.body.appendChild(el);
    requestAnimationFrame(() => setVisible(true));

    return () => {
      document.body.removeChild(el);
    };
  }, [el]);

  const handleClick = () => {
    setVisible(false);
    setTimeout(onClick, 600);
  };

  return ReactDOM.createPortal(
    <div
      className={`${styles.OverlayPortal} ${visible ? styles.visible : ""}`}
      onClick={handleClick}
    />,
    el
  );
};

export default OverlayPortal;
